import {Button as _Button, Avatar, Box} from '@material-ui/core'
import Styled from '../../components/Styled'
import styles from './styles'

export const Root = Styled(Box, styles.root)
export const Button = Styled(_Button, styles.button)
export const Thumbnail = Styled(Avatar, styles.thumbnail)
